import styles from "./FormField.module.css";

interface FormFieldProps {
	label: string;
	error?: string;
	children: React.ReactNode;
	required?: boolean;
	className?: string | undefined;
}

export function FormField({ label, error, children, required, className }: FormFieldProps) {
	return (
		<div className={[styles.wrapper, className].filter(Boolean).join(" ")}>
			<label className={styles.label}>
				{label}
				{required && <span className={styles.required}>*</span>}
			</label>
			{children}
			{error && <span className={styles.error}>{error}</span>}
		</div>
	);
}
